import { Outlet } from 'react-router-dom';
import Footer from '@/components/Footer';
import Header from '@/components/Header';

function Layout() {
  return (
    <div className="min-h-screen bg-[#F4EFE6] text-[#1E3A5F]">
      <a
        href="#contenido"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:bg-[#1E3A5F] focus:px-4 focus:py-2 focus:text-[#F4EFE6]">

        Saltar al contenido
      </a>
      <Header />
      <main id="contenido">
        <Outlet />
      </main>
      <Footer />
    </div>);

}

export default Layout;